define('viewmodels/work',[], function () {
  return {
    title: "Portfolio",
    portfolioItems: [
      {
        title: "Hashtag Dungeon Website",
        description: "indie game landing-page website",
        img: "https://drive.google.com/uc?id=1nDP7G3midWkIphFUJZJPAqAEbAOQyU_M",
        link: {
          url: "http://hashtagdungeon.com",
          active: true,
        },
        tags: ["2014", "jQuery", "CSS"],
      },
      {
        title: "Negative",
        description:
          "image processing tool for photo negatives (University final-year project)",
        img: "https://drive.google.com/uc?id=1KTGSjho57nZ-r5NVqV-pxavHoR1nLX3S",
        link: {
          url: "https://github.com/shameen/negative",
          active: true,
        },
        tags: ["2014", "MATLAB", "GUI", "Image Processing"],
      },
      {
        title: "Timetabling System",
        description:
          "database-driven ASP.NET timetabling system (University team project)",
        img: "https://drive.google.com/uc?id=1BOphILsUVQIMETT5nZSuk3mel4SRvU6X",
        link: {
          url: null,
          active: false,
        },
        tags: ["2013", "ASP.NET", "SQL Server", "Bootstrap"],
      },
      {
        title: "Phil Wolstenholme Photography",
        description: "multi-page website with self-made jquery photo gallery",
        img: "https://drive.google.com/uc?id=16PlyXjPWSd3C3xg3oQQkZ5RNWayDvj0k",
        link: {
          url: "http://philwolstenholme.com/",
          active: false,
        },
        tags: ["2012", "jQuery", "CSS"],
      },
      {
        title: "Propah Job Studios Website",
        description:
          "wordpress theme <small>(and previously, <a href='http://dl.dropbox.com/u/698380/propah/index.html'>simple HTML websites</a>)</small>",
        img: "https://drive.google.com/uc?id=1jZ5ndPX8b18SDANk6m6WeyBkWhXbUGWT",
        link: {
          url: "http://propahjobstudios.co.uk/",
          active: false,
        },
        tags: ["2010", "WordPress", "PHP", "CSS"],
      },
      {
        title: "snpt, online textbox",
        description:
          "text storage and history <small>(<a href='http://shameen.info/snpt/beta'>beta</a>)</small>",
        img: "https://drive.google.com/uc?id=1E9sxcqUFEL-V9yBGeBzBQ5HkOoEUSHts",
        link: {
          url: "http://shameen.info/snpt",
          active: true,
        },
        tags: ["2010", "PHP", "MySQL"],
      },
      {
        title: "JR Ambulance Medical Resources",
        description: "quote calculator",
        img: "https://drive.google.com/uc?id=1uprwPt7Ta3ioV5B4QuPNEJnnjZh9FPFj",
        link: {
          url: "http://www.jr-ambulance.co.uk/calculator/medical_resources_calculator_AIO.html",
          active: false,
        },
        tags: ["2011", "JavaScript"],
      },
      {
        title: "Forbidden Memories Database",
        description: "card game database browser and preview",
        img: "https://drive.google.com/uc?id=1Ii6gFpgXcWycBZDv0NVGECHaWx_Nb49f",
        link: {
          url: "http://shameen.info/fmr",
          active: true,
        },
        tags: ["2010", "PHP", "MySQL", "jQuery", "jQuery UI"],
      },
      {
        title: "FI Windows & Conservatories",
        description: "basic website with gallery and effects",
        img: "https://drive.google.com/uc?id=12tCqvY-KPDp4t_qog6768b8ql0Z3PtQs",
        link: {
          url: "http://fiwindows.com/",
          active: false,
        },
        tags: ["2009", "jQuery"],
      },
      {
        title: "iAlaina 30-second intro",
        description: "3D main titles based on the the TV show 'iCarly'",
        img: null, //TODO: vimeo embed?
        link: {
          url: "http://vimeo.com/10457730",
          active: true,
        },
        tags: ["2011", "3D", "After Effects", "Video", "VFX"],
      },
    ],
  };
});

